export default __webpack_public_path__ + "assets/35a6ff.svg";